define('rebrush/components/product/view/configurable-options-help',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'magnific-popup'
], function(
    $,
    _,
    Component,
    BEM
) {
    return Component.create({
        block:					null,

        $init: function() {
            this.block = BEM.block('product-view');
            this.block.getElements('configurable-options-help-link').magnificPopup({
                type:'inline',
                midClick: true
            });
        }
    });
});
